import React, { Component } from 'react'
import { connect } from 'react-redux'
import Submenu from '../../../../../../../Partidos/Components/SubmenuFases'
import ScrollIndicator from '../../../../../../../TablaDePosiciones/Components/ScrollIndicator'
import Toggle from '../Toogle'
import StatsPlayerCard from '../StatsPlayerCard'
import Legend from '../../../../../../../TablaDePosiciones/Components/Legend'
import Translator from '../../../../../../../../../requests/apa/Translator'
import Utils from '../../../../../../../../../utils/Utils'
import Device from '../../../../../../../../../devices/device'
import Asset from '../../../../../../../../../requests/apa/Asset'
import './_styles.scss'
import { getTabsSecondLevel, sendMetricScroll } from '../../../../../../../utils'
import { tabsStataticsContryDetail } from './constants'
import { setToggleState } from '../../../../../../../../../actions/toggles'

var REM_BASE = 15  // 1rem = 15px en este proyecto



/**
 * StatsBody
 * Cuerpo del tab "Estadísticas" del detalle de país.
 * Gestiona su propio estado de scroll de forma independiente.
 *
 * Props:
 *  children {node} — contenido adicional dentro del área de scroll
 */
class StatsBody extends Component {
  constructor (props) {
    super(props)
    this.state = {
      scrollTop: 0,
      maxScroll: 0,
      activeSubTab: 'attacks'
    }
    this.scrollRef = null
    this.firstScrollDone = false
    this.scrollMilestonesSent = new Set()
    this.handleScrollKeyDown = this.handleScrollKeyDown.bind(this)
    this.setScrollRef = function (el) { this.scrollRef = el; if (el) el.scrollTop = this.state.scrollTop }.bind(this)
    this.onSubTabNavigate = this.onSubTabNavigate.bind(this)
    this.handleSubmenuKeyDown = this.handleSubmenuKeyDown.bind(this)
    this.handleToggleKeyDown = this.handleToggleKeyDown.bind(this)
    this.handleToggleChange = this.handleToggleChange.bind(this)
    this.keys = Device.getDevice().getKeys()

    this.tabs = getTabsSecondLevel(tabsStataticsContryDetail)
  }

  componentDidMount () {
    setTimeout(function () {
      var first = document.querySelector('.stats-body__submenu-tab')
      if (first) first.focus()
    }, 0)
  }

  onSubTabNavigate (direction) {
    var SUB_TABS = ['attacks', 'defenses', 'goalkeeper']
    var current = SUB_TABS.indexOf(this.state.activeSubTab)
    var next = current + direction
    if (next < 0 || next >= SUB_TABS.length) return
    this.firstScrollDone = false
    this.scrollMilestonesSent = new Set()
    this.setState({ activeSubTab: SUB_TABS[next], scrollTop: 0, maxScroll: 0 }, function () {
      if (this.scrollRef) this.scrollRef.scrollTop = 0
    }.bind(this))
  }

  handleToggleChange (active) {
    this.props.setToggleState('stats-body', active)
  }

  handleSubmenuKeyDown (e) {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (currentKey !== 'UP' && currentKey !== 'DOWN') return
    e.preventDefault()
    e.stopPropagation()
    if (currentKey === 'UP') {
      var mainMenuTab = document.querySelector('.country-details-body__tabs .focusable')
      if (mainMenuTab) mainMenuTab.focus()
    } else {
      var toggle = document.querySelector('.stats-body__header .toggle')
      if (toggle) toggle.focus()
    }
  }

  handleToggleKeyDown (e) {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (currentKey !== 'UP' && currentKey !== 'DOWN' && currentKey !== 'LEFT') return
    e.preventDefault()
    e.stopPropagation()
    if (currentKey === 'UP') {
      var subTab = document.querySelector('.stats-body__submenu-tab--active, .stats-body__submenu-tab--active-focused')
      if (subTab) subTab.focus()
    } else {
      var scrollIndicator = document.querySelector('.stats-body__scrollbar')
      if (scrollIndicator) scrollIndicator.focus()
    }
  }

  handleScrollKeyDown (e) {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
    if (!currentKey) return

    const el = this.scrollRef
    const firstRow = el ? el.querySelector('.stats-players-row') : null
    const actualRowPx = firstRow ? firstRow.offsetHeight + 20 : 58  // 20px = margin-bottom de .stats-players-row
    const STEP = actualRowPx * (this.firstScrollDone ? 1 : 0.75)
    const MAX_SCROLL = el ? el.scrollHeight - el.clientHeight : 0
    var next = this.state.scrollTop

    if (currentKey === 'UP') {
      e.preventDefault()
      e.stopPropagation()
      if (this.state.scrollTop === 0) {
        var toggle = document.querySelector('.stats-body__header .toggle')
        if (toggle) toggle.focus()
        return
      }
      next = Math.max(0, next - STEP)
    } else if (currentKey === 'DOWN') {
      e.preventDefault()
      e.stopPropagation()
      next = Math.min(MAX_SCROLL, next + STEP)
    } else if (currentKey === 'RIGHT') {
      e.preventDefault()
      e.stopPropagation()
      var toggle = document.querySelector('.stats-body__header .toggle')
      if (toggle) toggle.focus()
      return
    } else {
      return
    }

    this.firstScrollDone = next > 0 // Se resetea automáticamente cuando next llega a 0 (top del scroll), por lo que el siguiente DOWN vuelve a usar 0.75.
    this.setState({ scrollTop: next, maxScroll: MAX_SCROLL })
    if (this.scrollRef) this.scrollRef.scrollTop = next

    const prevPercent = MAX_SCROLL > 0 ? Math.round(this.state.scrollTop / MAX_SCROLL * 100) : 0
    const nextPercent = MAX_SCROLL > 0 ? Math.round(next / MAX_SCROLL * 100) : 0
        
    const mainMenuLabel =  this.props.mainMenuLabel
    const parentTabLabel = this.props.parentTabLabel
    const childTabLabel = this.props.childTabLabel

    if (currentKey === 'DOWN') {
      const MILESTONES = [25, 50, 75]
      MILESTONES.forEach(m => {
        if (prevPercent < m && m <= nextPercent && !this.scrollMilestonesSent.has(m)) {
          this.scrollMilestonesSent.add(m)
          sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, m)
        }
      })
      if (next >= MAX_SCROLL && !this.scrollMilestonesSent.has(100)) {
        this.scrollMilestonesSent.add(100)
        sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, 100)
      }
    } else {
      if (prevPercent === 100 && nextPercent < 100) {
        this.scrollMilestonesSent.delete(100)
      }
      const MILESTONES = [25, 50, 75]
      MILESTONES.forEach(m => {
        if (nextPercent < m && m <= prevPercent && this.scrollMilestonesSent.has(m)) {
          this.scrollMilestonesSent.delete(m)
          sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, m)
        }
      })
    }
  }

  render () {
    var scrollTop = this.state.scrollTop
    var maxScroll = this.state.maxScroll
    var scrollRatio = maxScroll > 0 ? scrollTop / maxScroll : 0
    var activeSubTab = this.state.activeSubTab
    var children = this.props.children
    var toggleActive = this.props.toggleActive || false
    var dataStats = this.props.dataStats || {}

    var subTabDataMap = {
      attacks:    dataStats.transformedOffensive   || [],
      defenses:   dataStats.transformedDefensive   || [],
      goalkeeper: dataStats.transformedGoalkeeping || []
    }
    var activePlayers = (subTabDataMap[activeSubTab] || []).slice(0, toggleActive ? undefined : 4)

    const overlayPhotoUrl = Asset.get('eventodeportivo_placeholder_imagen_jugador_1')

    const STAT_COLUMNS_OFFENSIVE_LABELS = {
      leftItems: [
        { key: 'g',   label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_goles'), 5),   description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_goles'), 30) },
        { key: 'pag', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_pasesgol'), 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_pasesgol'), 30) },
        { key: 'tt',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_tirostotales'), 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_tirostotales'), 30) },
        { key: 'tap', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_tirosporteria'), 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_tirosporteria'), 30) }
      ],
      rightItems: [
        { key: 'pt',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_pasestotales'), 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_pasestotales'), 30) },
        { key: 're',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_regatesexito'), 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_regatesexito'), 30) },
        { key: 'fr',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_faltasrecibidas'), 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_faltasrecibidas'), 30) },
        { key: 'fj',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_fueradejuego'), 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_fueradejuego'), 30) }
      ]
    }
    const STAT_COLUMNS_DEFENSIVE_LABELS = {
      leftItems: [
        { key: 'i',  label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_intercepciones'), 5),  description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_intercepciones'), 30) },
        { key: 'eg', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_entradasganadas'), 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_entradasganadas'), 30) }
      ],
      rightItems: [
        { key: 'fc', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_faltascometidas'), 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_faltascometidas'), 30) },
        { key: 'ta', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_tarjetasamarillas'), 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_tarjetasamarillas'), 30) }
      ]
    }
    const STAT_COLUMNS_GOALKEEPING_LABELS = {
      leftItems: [
        { key: 'pp', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_paradasportero'), 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_paradasportero'), 30) } // PP -> Figma
      ],
      rightItems: [
        { key: 'pac', label: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_titulo_porteriacero'), 5), description: Utils.cutPlayerString(Translator.get('eventodeportivo_siglas_texto_porteriacero'), 30) } // PAC -> Figma
      ]
    }
    
    return (
      <div className='stats-body'>
        <div onKeyDown={this.handleSubmenuKeyDown}>
          <Submenu
            tabs={this.tabs}
            activeTab={activeSubTab}
            onNavigate={this.onSubTabNavigate}
            classNames={{
              tab: 'stats-body__submenu-tab',
              active: 'stats-body__submenu-tab--active',
            }}
          />
        </div>
        <div className='stats-body__header' onKeyDown={this.handleToggleKeyDown}>
          <Toggle active={toggleActive} label={Utils.cutPlayerString(Translator.get('eventodeportivo_paises_texto_titulo_verestadistica'), 24)} onChange={this.handleToggleChange} />
        </div>
        <div
          className='stats-body__scroll'
          ref={this.setScrollRef}
        >
          {activePlayers.reduce(function (rows, player, i) {
            if (i % 2 === 0) rows.push([])
            rows[rows.length - 1].push(player)
            return rows
          }, []).map(function (pair, pairIndex) {
            return (
              <div key={pairIndex} className='stats-players-row'>
                <StatsPlayerCard
                  playerName={pair[0].playerName}
                  jerseyNumber={pair[0].jerseyNumber}
                  photoUrl={pair[0].photoUrl || overlayPhotoUrl}
                  stats={pair[0].stats}
                  className='stats-players-row__left'
                  tabSelected={activeSubTab}
                />
                {pair[1] && (
                  <StatsPlayerCard
                    playerName={pair[1].playerName}
                    jerseyNumber={pair[1].jerseyNumber}
                    photoUrl={pair[1].photoUrl || overlayPhotoUrl}
                    stats={pair[1].stats}
                    tabSelected={activeSubTab}
                  />
                )}
              </div>
            )
          })}
          {children}
          {function () {
            var legendLabels = STAT_COLUMNS_OFFENSIVE_LABELS
            if (activeSubTab === 'defenses') legendLabels = STAT_COLUMNS_DEFENSIVE_LABELS
            else if (activeSubTab === 'goalkeeper') legendLabels = STAT_COLUMNS_GOALKEEPING_LABELS
            return (
              <Legend
                leftItems={legendLabels.leftItems}
                rightItems={legendLabels.rightItems}
              />
            )
          }()}
        </div>
        <ScrollIndicator
          onKeyDown={this.handleScrollKeyDown}
          scrollRatio={scrollRatio}
          className='stats-body__scrollbar'
          trackHeightRem={34.67}
          thumbHeightRem={11.4}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    toggleActive: state.toggles['stats-body']
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setToggleState: function (toggleId, active) {
      return dispatch(setToggleState(toggleId, active))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StatsBody)



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/StatsBody/index.jsx